<template>
    <span
      class="loading loading-dots loading-lg text-theme-primary bg-black" :title="$t('accessibility.loading')"
    ></span>
</template>
